import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import _ from 'lodash';

import { setImportPayCsvJobInvisible, getImportPayCsvJobs } from 'src/reducers/employees/employeePays';
import { Close } from 'jbc-front/components/icons';
import { JobFailed, JobInprogress, JobSuccess } from 'src/components/JobStatus';
import { scrollToTop } from 'src/utils/Utils';

import styles from './ImportPayCsvJobStatus.scss';

const ImportJobResult = ({ tasks, status, hideImportJobResults }) => {
  const { t } = useTranslation();
  let statusText = t('features.EmployeePays.components.ImportPayCsvJobStatus.Salary_CSV_import_completed');
  let tasksStyle = styles.tasksSuccess;

  if (status === 'failed') {
    statusText = t('features.EmployeePays.components.ImportPayCsvJobStatus.Salary_CSV_import_failed');
    tasksStyle = styles.tasksFailed;
  } else if (status === 'inProgress' || status === 'waiting') {
    statusText = t('features.EmployeePays.components.ImportPayCsvJobStatus.Salary_CSV_import_in_process');
    tasksStyle = styles.tasksInprogress;
  }

  return (
    <React.Fragment>
      {!isEmpty(tasks) &&
        tasks.length > 0 && (
          <div className={tasksStyle}>
            <div className={styles.inner}>
              {status === 'success' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideImportJobResults(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>{tasks.map(task => <JobSuccess key={task.id} statusText={statusText} {...task} />)}</ul>
                </React.Fragment>
              )}
              {status === 'failed' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideImportJobResults(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>{tasks.map(task => <JobFailed key={task.id} statusText={statusText} {...task} />)}</ul>
                </React.Fragment>
              )}
              {(status === 'inProgress' || status === 'waiting') && (
                <React.Fragment>
                  <ul className={styles.list}>{tasks.map(task => <JobInprogress key={task.id} statusText={statusText} {...task} />)}</ul>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      {isEmpty(tasks) && null}
    </React.Fragment>
  );
};

class ImportPayCsvJobStatus extends React.Component {
  componentDidUpdate(prevProps) {
    const { importJobs = {} } = this.props;
    const newFailedJobs = _.get(importJobs, 'failed', []);
    const currentFailedJobs = _.get(prevProps, 'importJobs.failed', []);
    const hasError = newFailedJobs.length > currentFailedJobs.length;

    if (hasError) {
      scrollToTop();
    }
  }
  render() {
    const { importJobs = {}, hideImportJobResults } = this.props;
    const sortCondition = (_status1, status2) => {
      if (status2 === 'inProgress' || status2 === 'waiting') return -1; // In progress tasks are on bottom
      if (status2 === 'success') return -1; // Successful tasks are on top
      return 0; // Failed tasks are in middle
    };
    return (
      <React.Fragment>
        {isEmpty(importJobs) ? null : (
          <div>
            {Object.keys(importJobs)
              .sort(sortCondition)
              .map(status => (
                <ImportJobResult key={status} tasks={importJobs[status]} status={status} hideImportJobResults={hideImportJobResults} />
              ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  importJobs: getImportPayCsvJobs(state)
});

const mapDispatchToProps = dispatch => ({
  hideImportJobResults: tasks => {
    if (isEmpty(tasks)) return;

    const taskIds = tasks.map(j => j.id).join('_');
    dispatch(setImportPayCsvJobInvisible(taskIds));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportPayCsvJobStatus);
